import { uuCompactArrayOrObject } from 'lodash';
import { phonesInitialValues } from 'src/common/form/Profile/EditPhoneNumbers/utils';
import { emailsInitialValues } from 'src/common/form/Profile/EditEmailAddresses/utils';

export default function getInitialValuesFromContact(contact = {}) {
  const phones = phonesInitialValues(contact.phone_numbers);
  const emails = emailsInitialValues(contact.email_addresses);

  // Contact Preferences
  function transformContactPreferences(contactPreferences) {
    const timeslots = {};

    if (contactPreferences?.timeslots) {
      Object.entries(contactPreferences.timeslots).forEach(([day, slots]) => {
        if (slots !== null) {
          timeslots[day] = slots.map(({ start_time, end_time }) => ({
            start_time,
            end_time,
          }));
        }
      });
    }

    const transformed = {
      contact_notes: contactPreferences?.contact_notes,
      preferred_contact_methods: contactPreferences?.preferred_contact_methods,
      timeslots,
      voice_mail_ok: contactPreferences?.voice_mail_ok?.toString(),
    };
    return transformed;
  }

  const contactPreferencesInitialValues = Object.keys(contact).length > 0 ?
    transformContactPreferences(contact.contact_preference) :
    undefined;

  // Record Languages
  const existingRecordLanguages = contact?.preferred_languages || [];

  // MultiSelectField expects array of values (language names as strings)
  const existingSpokenLanguages = existingRecordLanguages
  .filter((item) => item.record_language_type === 'spoken')
  .map((item) => item.language_name);

  const existingWrittenLanguages = existingRecordLanguages
  .filter((item) => item.record_language_type === 'written')
  .map((item) => item.language_name);

  const compactedValues = uuCompactArrayOrObject({
    addresses: contact.addresses,
    date_of_birth: contact.date_of_birth,
    email_addresses: emails,
    ethnicity: contact.ethnicity,
    first_name: contact.first_name,
    gender: contact.gender,
    last_name: contact.last_name,
    marital_status: contact.marital_status,
    military: contact.military,
    phone_numbers: phones,
    preferred_communication_method: contact.preferred_communication_method,
    preferred_communication_time_of_day: contact.preferred_communication_time_of_day,
    race: contact.race,
    ssn_last4: contact.ssn_last4,
    contact_preferences: contactPreferencesInitialValues,
    preferred_spoken_languages: existingSpokenLanguages,
    preferred_written_languages: existingWrittenLanguages,
  });

  // Preserve sexuality and ssn fields even when empty/null
  // These get stripped by uuCompactArrayOrObject but are needed for form initialization
  const initialValues = {
    ...compactedValues,
    // Only include these if the contact has data (to avoid overwriting defaults for new contacts)
    ...(Object.keys(contact).length > 0 && {
      sexuality: Array.isArray(contact.sexuality) ? contact.sexuality : [],
      sexuality_other: contact.sexuality_other || '',
      ssn: contact.ssn || '',
    }),
  };

  return initialValues;
}
